import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { TRANSACTION_TABS, type TransactionTab } from '@/features/billing/billing-shared';
import { TransactionDetailPage } from '@/features/billing/transactions-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Détail d'une transaction (lot L01). L'onglet actif vit dans l'URL (`?tab=`). */
export const Route = createFileRoute('/$tenant/billing/transactions/$transactionId')({
  validateSearch: (search: Record<string, unknown>): { tab: TransactionTab } => ({
    tab: TRANSACTION_TABS.parse(search['tab']),
  }),
  component: TransactionRoute,
});

function TransactionRoute() {
  const { tenant, transactionId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="transactions"
      crumbs={[{ label: t('nav.items.transactions') }, { label: transactionId, mono: true }]}
    >
      <TransactionDetailPage
        tenantId={tenant}
        transactionId={transactionId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
